import { proxy } from 'valtio';

export const currentBoardElementsState: {
  isCreateDisabled: boolean;
} = proxy({
  /**
   * Disables or enables the UI elements that allow users to create new elements on the board. I.e bottom toolbar, side nav items, etc.
   */
  isCreateDisabled: false,
});

export const disableBoardElementsCreate = () => {
  currentBoardElementsState.isCreateDisabled = true;
};
export const enableBoardElementsCreate = () => {
  currentBoardElementsState.isCreateDisabled = false;
};
